import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import {
  createGroup,
  deleteGroup,
  getGroupList,
  updateGroup,
} from "../../../../redux/reducers/groupSlice";
import { AppColors } from "../../../../util/AppColors";
import { tblGrayBack } from "../../../../util/object";
import { canWriteModule } from "../../../../util/roleModuleAccess";

const defObj = { dataSharing: {} };

function Group({ onGroupClick }) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ groupName: "" });
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { list: groupList, totalRecords } = useSelector((state) => state.group);
  const itemsPerLoad = 10;
  const canManagePlan = canWriteModule("plan");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { dataSharing } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return { dataSharing: reqData?.dataSharing ?? {} };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    onApiCall(1);
  }, [search]);

  const onApiCall = (pge = 1, url = "") => {
    setPage(pge);
    const baseQuery = `?page=${pge}&itemSize=${itemsPerLoad}${search?.length > 0 ? `&search=${search}` : ""}&shareData=${dataSharing?.planData ?? false}`;
    dispatch(getGroupList(url || baseQuery));
  };

  const handleAddOrUpdate = () => {
    if (!form.groupName) return;
    if (editIndex !== null) {
      const group = groupList[editIndex];
      dispatch(
        updateGroup({ groupId: group.roomId, groupName: form.groupName }),
      ).then(() => {
        onApiCall();
      });
    } else {
      dispatch(createGroup(form)).then(() => {
        onApiCall();
      });
    }
    handleCloseDrawer();
  };

  const handleEdit = (index) => {
    const group = groupList[index];
    setForm({ groupName: group.groupName });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    dispatch(deleteGroup({ groupId: deleteId })).then(() => {
      setDelModVisible(false);
      setDeleteId(null);
    });
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteId(null);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setForm({ groupName: "" });
    setEditIndex(null);
  };

  // const filteredRows = [...groupList]
  //   .filter((row) => row.groupName.toLowerCase().includes(search.toLowerCase()))
  //   .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const totalPage = Math.ceil(totalRecords / itemsPerLoad);

  return (
    <Box
    // p={3}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        // mt={2}
        flexWrap="wrap"
      >
        <Box
          display="flex"
          gap={2}
          mx="auto"
          // mb={2}
        >
          <div style={{ width: "500px" }}>
            <CustomTextField
              placeholder="Search"
              fullWidth
              backgroundColor={AppColors.lightBlue2}
              value={search}
              handleChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {/* <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          /> */}
          {canManagePlan ? (
            <Button variant="contained" onClick={() => setOpenDrawer(true)}>
              Create
            </Button>
          ) : null}
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Groups: {totalRecords ?? 0}
        </Typography>
      </Box>

      <Box sx={{ mt: 2, maxHeight: "70vh", overflowY: "auto" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  "S.No",
                  "Group Name",
                  "Created By",
                  "Created Date",
                  "Actions",
                ].map((li, i) => (
                  <TableCell
                    style={tblGrayBack}
                    className="txt-semi-bold fs12"
                    key={i + li}
                  >
                    {li}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {totalRecords === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                groupList?.map((row, index) => (
                  <TableRow key={row.roomId}>
                    <TableCell>
                      {(page - 1) * itemsPerLoad + (index + 1)}
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={() => onGroupClick(row.roomId, row.groupName)}
                      >
                        {row.groupName}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.userName || "-"}</TableCell>
                    <TableCell>
                      {new Date(row.createdDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {canManagePlan ? (
                        <>
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => handleEdit(index)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => handleDeleteClick(row.roomId)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
            {totalPage > 1 ? (
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={12}>
                    <div className="flex-end">
                      <Pagination
                        count={totalPage}
                        variant="outlined"
                        color="primary"
                        page={page}
                        onChange={handleChangePage}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableFooter>
            ) : null}
          </Table>
        </TableContainer>
      </Box>

      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Group" : "Create Group"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Group Name"
            value={form.groupName}
            onChange={(e) => setForm({ ...form, groupName: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Group;
